import api from "./configuration";
import apiUrl from "./url";
import {MESSAGES_READ_EVENT} from "@/utils/messages";

const USE_AUTH_INTERCEPTOR = true;
const BASE = apiUrl + "/Messages";

export const MessagesAPI = {
	// ── Conversations ─────────────────────────────────────────────────────────

	getConversations: async () => {
		const response = await api.request({
			method: "GET",
			url: BASE + "/conversations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},

	getOrCreateDirect: async (data) => {
		const response = await api.request({
			method: "POST",
			url: BASE + "/conversations/direct",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},

	createGroup: async (data) => {
		const response = await api.request({
			method: "POST",
			url: BASE + "/conversations/group",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},

	addParticipant: async (conversationId, data) => {
		const response = await api.request({
			method: "POST",
			url: `${BASE}/conversations/${conversationId}/participants`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},

	// ── Messages ──────────────────────────────────────────────────────────────

	getMessages: async (conversationId, params) => {
		const response = await api.request({
			method: "GET",
			url: `${BASE}/conversations/${conversationId}/messages`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});
		return response.data;
	},

	sendMessage: async (conversationId, data) => {
		const response = await api.request({
			method: "POST",
			url: `${BASE}/conversations/${conversationId}/messages`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},

	markRead: async (conversationId) => {
		const response = await api.request({
			method: "PUT",
			url: `${BASE}/conversations/${conversationId}/read`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		window.dispatchEvent(new Event(MESSAGES_READ_EVENT));
		return response.data;
	},

	deleteMessage: async (messageId) => {
		const response = await api.request({
			method: "DELETE",
			url: `${BASE}/${messageId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},

	// ── Unread count ──────────────────────────────────────────────────────────

	getUnreadCount: async () => {
		const response = await api.request({
			method: "GET",
			url: BASE + "/unread",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
};
